import React from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Card, Skeleton } from 'antd';
import './styles.less';

const ProfileCardSkeleton = () => (
  <Card
    className="profile-card-skeleton"
    actions={[<EditOutlined key="edit-skeleton" />, <DeleteOutlined key="delete-skeleton" />]}
  >
    <div className="profile-card-skeleton__body">
      <Skeleton paragraph={{ rows: 2 }} active />
    </div>
  </Card>
);

export default ProfileCardSkeleton;
